document.addEventListener('DOMContentLoaded', function () {
	// Get ALL pagination containers, not just the first one
	const paginationContainers = document.querySelectorAll('.custom-swiper-pagination');

	if (paginationContainers.length > 0) {
		paginationContainers.forEach(function(paginationContainer) {
			// Get the carousel ID from the pagination container
			const carouselId = paginationContainer.getAttribute('data-carousel-id');
			if (!carouselId) return; // Skip if no carousel ID

			// Get styling attributes
			const width = paginationContainer.getAttribute('data-width');
			const height = paginationContainer.getAttribute('data-height');
			const backgroundColor = paginationContainer.getAttribute('data-background-color');
			const borderRadius = paginationContainer.getAttribute('data-border-radius');

			// Initialize an observer to handle dynamically created bullets
			const observer = new MutationObserver(function(mutations) {
				// When bullets are added to this specific pagination container
				const bullets = paginationContainer.querySelectorAll('.swiper-pagination-bullet');
				bullets.forEach((bullet) => {
					bullet.style.backgroundColor = backgroundColor;
					bullet.style.width = `${width}px`;
					bullet.style.height = `${height}px`;
					bullet.style.borderRadius = `${borderRadius}px`;
				});
			});

			// Start observing the pagination container for child changes
			observer.observe(paginationContainer, { childList: true });
			
			// Also apply styles to any bullets already present
			const bullets = paginationContainer.querySelectorAll('.swiper-pagination-bullet');
			bullets.forEach((bullet) => {
				bullet.style.backgroundColor = backgroundColor;
				bullet.style.width = `${width}px`;
				bullet.style.height = `${height}px`;
				bullet.style.borderRadius = `${borderRadius}px`;
			});
		});
	}
});
